import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const InsideTempGlyph = /*#__PURE__*/createElement("g", {
  id: "inside-temperature"
}, /*#__PURE__*/createElement("path", {
  d: "M43.1,27.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2-0.1-0.3-0.1-0.5,0 c-0.2,0-0.5,0.2-0.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.2-0.1,0.3-0.1,0.5v15.2h2.4V27.5z M41.9,60.9c-5.7,0-7.9-7.4-3.1-10.5 V27.5c0-0.4,0.1-0.9,0.3-1.3c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.2,0.4-0.3,0.6-0.4c0.3-0.2,0.7-0.3,1.1-0.4c0.4-0.1,0.9,0,1.4,0.1 c0.4,0.1,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.6,0.8,1c0.2,0.4,0.3,0.9,0.3,1.3v22.9C49.8,53.5,47.6,60.9,41.9,60.9"
}), /*#__PURE__*/createElement("path", {
  d: "M41.8,14.3c0.1-0.1,0.1-0.1,0.2,0c8.1,8.9,16.2,17.8,24.3,26.7c0.6,0.6,1.5,0.6,2.1,0.1c0.6-0.6,0.6-1.5,0.1-2.1 C60.3,29.9,52,20.8,43.7,11.8c-1-1.1-2.6-1.1-3.6,0C31.9,20.8,23.6,29.9,15.3,39c-0.6,0.6-0.5,1.5,0.1,2.1c0.6,0.6,1.5,0.5,2.1-0.1 C25.6,32.1,33.7,23.2,41.8,14.3"
}), /*#__PURE__*/createElement("path", {
  d: "M60.9,65.9c0,0.1,0,0.1-0.1,0.1H23.2c-0.1,0-0.1,0-0.1-0.1V52.2v-6.9c0-0.9,0.2-1.7,0-2.7c-0.1-0.5-0.4-0.8-0.9-1 c-0.9-0.3-1.9,0.3-2,1.3c-0.1,2.3,0,4.6,0,6.8v6.9v6.9v3c0,1.4,1.1,2.5,2.4,2.5h38.9c1.4,0,2.4-1.1,2.4-2.5v-3v-6.9v-6.9 c0-2.3,0.1-4.6,0-6.9c-0.1-1-1-1.7-2-1.3c-0.5,0.2-0.8,0.5-0.9,1c-0.2,0.9,0,1.8,0,2.6v6.9V65.9"
}));
const InsideTemp = createSvg({
  name: 'inside_temp',
  path: InsideTempGlyph
});

export default InsideTemp;
export { InsideTempGlyph };
